var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("img", {
      staticClass: "img--mobile",
      attrs: {
        alt: "Page not found",
        src: _vm.$store.state.imagesCdn + "/seats-mobile.png"
      }
    }),
    _vm._v(" "),
    _c("img", {
      staticClass: "img--desktop",
      attrs: {
        alt: "Page not found",
        src: _vm.$store.state.imagesCdn + "/seats.png"
      }
    })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("h1", [_vm._v("Nothing to see here.")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v("Don’t worry, we’ll get you back on track."),
        _c("br"),
        _vm._v("Try searching again.")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }